import Swal from "sweetalert2";
import type { SweetAlertIcon } from "sweetalert2";
import type { FC } from "react";

interface CustomAlertProps {
  title: string;
  text?: string;
  icon: SweetAlertIcon;
  confirmButtonText?: string;
  showConfirmButton?: boolean;
  confirmButtonColor?: string;
  onConfirm?: (value?: string) => void;
  showCancelButton?: boolean;
  cancelButtonText?: string;
  cancelButtonColor?: string;
  onCancel?: () => void;
  showInput?: boolean;
  inputPlaceHolder?: string;
  inputValidationMsg?: string;
  isEdit?: boolean;
  inputValue?: string;
}

const CustomAlert: FC<CustomAlertProps> = ({
  title,
  text = undefined,
  icon,
  confirmButtonText,
  showConfirmButton = true,
  confirmButtonColor,
  onConfirm,
  showCancelButton,
  cancelButtonText,
  cancelButtonColor,
  onCancel,
  showInput = false,
  inputPlaceHolder,
  inputValidationMsg,
  isEdit = false,
  inputValue = "",
}) => {
  Swal.fire({
    title,
    text,
    icon,
    showConfirmButton,
    confirmButtonText,
    confirmButtonColor,
    showCancelButton,
    cancelButtonText,
    cancelButtonColor,
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: {
      confirmButton: "confirm-button-class",
      cancelButton: "cancel-button-class",
    },
    input: showInput ? "text" : undefined,
    inputPlaceholder: showInput ? inputPlaceHolder : undefined,
    inputValue: isEdit ? inputValue : "",
    didOpen: showInput
      ? () => {
          const confirmButton = Swal.getConfirmButton();
          const inputField = Swal.getInput();
          if (confirmButton && inputField) {
            (confirmButton as HTMLButtonElement).disabled =
              inputField.value.trim() === "";
            inputField.addEventListener("keyup", () => {
              (confirmButton as HTMLButtonElement).disabled =
                inputField.value.trim() === "";
            });
          }
        }
      : undefined,
    preConfirm: showInput
      ? (inputValue) => {
          if (!inputValue) {
            Swal.showValidationMessage(inputValidationMsg || "");
          }
          return inputValue;
        }
      : undefined,
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      return onConfirm(showInput ? result.value : undefined);
    } else if (result.isDismissed && onCancel) {
      return onCancel();
    }
  });

  return null;
};

export { CustomAlert };
export type { CustomAlertProps };
